import { ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { requestService } from "@/lib/nav";

export const FinalCta = () => (
  <section className="py-20 lg:py-28 bg-sand-muted" data-testid="final-cta-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="rounded-3xl bg-forest text-white px-8 py-14 lg:px-16 lg:py-20 relative overflow-hidden grain">
          <div className="relative max-w-3xl">
            <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">
              Sie suchen einen zuverlässigen Partner für Ihr Objekt?
            </h2>
            <p className="mt-5 text-lg text-white/75 leading-relaxed">
              Ob regelmäßige Gebäudereinigung, einmaliger Reinigungsauftrag oder ergänzende
              Objektpflege – beschreiben Sie uns kurz Ihren Bedarf und erhalten Sie ein individuell
              abgestimmtes Angebot.
            </p>
            <button onClick={() => requestService("")} data-testid="final-cta-button" className="mt-8 inline-flex items-center gap-2 rounded-md bg-gold px-7 py-3.5 text-charcoal font-semibold hover:bg-gold-dark hover:-translate-y-0.5 transition-[transform,background-color] duration-200">
              Kostenloses Angebot anfordern <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
